import _ from 'lodash';
import { EventBus, EventType } from 'scbk-services/event-bus/bus/event-bus';
import { JwtEvent, unwrapSecureData } from './jwt-commons';
import { JwtTokenRepository } from './jwt-token-repository';

export class JwtProcessStateManager {
    // 싱글톤 인스턴스
    private static instance: JwtProcessStateManager | null = null;

    //토큰 재발급 진행중 여부
    private nowHandling401: boolean;

    //403 에러 처리 진행중 여부
    private nowHandling403: boolean;

    //토큰 재발급 대기 큐
    private failedQueue: any[];

    //토큰 관리자
    private tokenManager: JwtTokenRepository = JwtTokenRepository.getInstance();

    //기본 생성자
    private constructor() {
        this.nowHandling401 = false;
        this.nowHandling403 = false;
        this.failedQueue = [];
    }

    /**
     * 싱글톤 인스턴스 획득
     * @returns
     */
    public static getInstance(): JwtProcessStateManager {
        if (!this.instance) {
            this.instance = new JwtProcessStateManager();
        }
        return this.instance;
    }

    public isNowHandling401(): boolean {
        return this.nowHandling401;
    }

    public setNowHandling401(value: boolean): void {
        this.nowHandling401 = value;
    }

    public isNowHandling403(): boolean {
        return this.nowHandling403;
    }

    public setNowHandling403(value: boolean): void {
        this.nowHandling403 = value;
    }

    public getFailedQueue(): any[] {
        return this.failedQueue;
    }

    public pushFailedQueue(resolve: any, reject: any): void {
        this.failedQueue.push({ resolve, reject });
    }

    /**
     * JWT 처리 상태 초기화
     *
     */
    public resetJwtProcessState(needClearTokens: boolean): void {
        console.log(
            'jwt-process-state > resetJwtProcessState(에러 응답처리-상태 초기화) - needClearTokens : ',
            needClearTokens,
        );

        // 상태 변수 초기화
        this.nowHandling401 = false;
        this.nowHandling403 = false;
        this.failedQueue = [];

        // 로컬스토리지에 저장되어 있는 토큰 삭제
        if (needClearTokens) {
            this.tokenManager.clearTokens();
        }

        console.log(
            'jwt-process-state > resetJwtProcessState(에러 응답처리-상태 초기화) - process-state :, ',
            {
                nowHandling401: this.nowHandling401,
                nowHandling403: this.nowHandling403,
                failedQueue: this.failedQueue,
            },
        );
    }

    /**
     * 토큰 재발급 대기 큐 처리
     * @param error
     * @param token
     */
    public processQueue(error: any, newAccessToken: string | null = null): void {
        console.log('jwt-process-state > processQueue(토큰 재발급 대기 큐 처리) - req : ', {
            error,
            newAccessToken,
        });

        this.failedQueue.forEach((promise) => {
            if (_.isNotEmpty(newAccessToken)) {
                promise.resolve(newAccessToken);
            } else {
                promise.reject(error);
            }
        });

        this.failedQueue = [];
    }

    /**
     * JWT 에러 처리 함수
     * 에러 처리 => 이벤트 발생
     * 요청 호출자는 무한 대기
     * 페이지 이동(프리로그인페이지) 하면서 대기중인 요청 호출자는 소멸
     * 단, failedQueue는 반드시 비워야 함
     * @param event
     * @returns
     */
    public handleJwtError(event: JwtEvent): Promise<never> {
        console.log('jwt-process-state > handleJwtError(에러 응답처리) - errorEvent : ', event);
        EventBus.getInstance().emit(EventType.JwtForbiden, event);
        return new Promise(() => {});
    }

    /**
     * 오류 응답 보류
     * @param instance
     * @param error
     * @returns
     */
    public holdFailedRequest(instance: any, error: any): Promise<any> {
        console.log('jwt-process-state > holdFailedRequest(에러 응답 보류) - processState : ', {
            httpStatus: error?.response?.status,
            retry: error?.config?._retry,
            nowHandling401: this.isNowHandling401(),
            nowHandling403: this.isNowHandling403(),
            failQueue: this.getFailedQueue(),
        });

        const originalRequest = error?.config;

        return new Promise((resolve, reject) => {
            console.log(
                `jwt-process-state > holdFailedRequest(에러 응답 보류) - pushFailedQueue(Queue 저장)`,
            );
            this.pushFailedQueue(resolve, reject);
        })
            .then((token) => {
                console.log(
                    'jwt-process-state > holdFailedRequest(에러 응답 보류) - then(Queue 저장 후 정상 처리)',
                );
                originalRequest.headers.Authorization = `Bearer ${token}`;
                unwrapSecureData(originalRequest);
                return instance(originalRequest);
            })
            .catch((error) => {
                console.warn(
                    'jwt-process-state > holdFailedRequest(에러 응답 보류) - catch(Queue 저장 후 오류 처리_아무것도 하지 않음) [error] : ',
                    error,
                );

                return new Promise(() => {});
            });
    }
}
